// material-ui
import { alpha } from '@mui/material/styles';

// ==============================|| DEFAULT THEME - CUSTOM SHADOWS ||============================== //

export default function CustomShadows(theme) {
  const { palette } = theme;
  const colors = palette.grey ? palette.grey : { A100: '#000000', 900: '#000000' };
  
  return {
    button: `0 2px #0000000b`,
    text: `0 -1px 0 rgb(0 0 0 / 12%)`,
    z1: `0px 2px 8px ${alpha(colors[900] || '#000000', 0.15)}`,
    primary: `0 0 0 2px ${alpha(palette.primary.main || '#000000', 0.2)}`,
    secondary: `0 0 0 2px ${alpha(palette.secondary.main || '#000000', 0.2)}`,
    error: `0 0 0 2px ${alpha(palette.error.main || '#000000', 0.2)}`,
    warning: `0 0 0 2px ${alpha(palette.warning.main || '#000000', 0.2)}`,
    info: `0 0 0 2px ${alpha(palette.info.main || '#000000', 0.2)}`,
    success: `0 0 0 2px ${alpha(palette.success.main || '#000000', 0.2)}`,
    primaryButton: `0 14px 12px ${alpha(palette.primary.main || '#000000', 0.2)}`,
    secondaryButton: `0 14px 12px ${alpha(palette.secondary.main || '#000000', 0.2)}`,
    errorButton: `0 14px 12px ${alpha(palette.error.main || '#000000', 0.2)}`,
    warningButton: `0 14px 12px ${alpha(palette.warning.main || '#000000', 0.2)}`,
    infoButton: `0 14px 12px ${alpha(palette.info.main || '#000000', 0.2)}`,
    successButton: `0 14px 12px ${alpha(palette.success.main || '#000000', 0.2)}`
  };
}
